<template>
  <el-form :model="form" status-icon class="tab-state-info" label-width="100px">
    <el-form-item label="审核状态：" prop="state">
      <div class="flex-box">
        <div class="state" :class="dialogData.auditState|auditStyle">{{ dialogData.auditState|auditState}}</div>
        <el-button v-if="dialogData.auditState =='AUDIT_NON'||dialogData.auditState =='AUDIT_NO_PASS'||dialogData.auditState =='RE_AUDIT_NO_PASS'"
          type="primary"
          plain
          @click="sendAudit(dialogData)">
          送审
        </el-button>
        <el-button v-if="dialogData.auditState =='AUDIT_NO_PASS'||dialogData.auditState =='RE_AUDIT_NO_PASS' || dialogData.auditState =='UNIFORM_AUDIT_NO_PASS'"
          type="primary" plain
          @click="checkReson(dialogData.reason)">查看原因
        </el-button>
      </div>
    </el-form-item>
    <el-form-item label="发布状态：" prop="always">
      <el-button type="primary" plain @click="goRelease">详情</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { fetchSingleProgram } from '@/resource/api/index'

export default {
  name: 'TabStateInfo',
  props: ['dialogData'],
  data () {
    return {
      form: {}
    }
  },
  methods: {
    // 送审
    sendAudit (row) {
      const data = {
        auditState: 'AUDIT_ING',
        memo: '',
        id: row.id,
        operator: this.$store.state.router.updateBySuffix
      }
      fetchSingleProgram(data).then((res) => {
        if (res.code == '1') {
          this.$emit('refresh')
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 查看未通过原因
    checkReson (reason) {
      this.$alert(reason, '原因', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    },
    // 查看详情
    goRelease () {
      this.$emit('goRelease')
    }
  }
}
</script>

<style lang="less">
.flex-box{
  display: flex;
  .state {
    font-size: 12px;
    font-weight: 400;
    color: #94979E;
    position: relative;
    .point {
      font-weight: bolder;
      font-size: 24px;
    }
  }
  .orange {
    color: orange;
  }
  .red {
    color: red;
  }
  .green{
    color: #6EB360;
  }
  .blue{
    color: #399FFD;
  }
  .state:before{
    content: "●";
    padding-right: 5px;
  }
  button{
    margin-left: 20px;
  }
}
</style>
